<template>
  <div class="ProfitabilityCalculatorWrapperCmp">
    <div class="wrapper">
      <div class="row1">
        <figure class="background">
          <slot name="background" />
        </figure>
        <div class="container">
          <div class="row">
            <div class="col-12 col-lg-5">
              <div class="negative-offset">
                <slot name="title" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row2">
        <div class="container pt-m">
          <div class="row">
            <div v-if="lgAndUp" class="col-12 col-lg-5 n-heading-2">
              <slot name="wysiwyg" />
            </div>
            <div class="col-12 col-lg-7">
              <slot name="calculator" />
            </div>
            <div v-if="!lgAndUp" class="col-12 col-lg-5 n-heading-2">
              <div class="pt-m pb-xxl">
                <slot name="wysiwyg" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//<slot name="calculator" />
import { lgAndUp, mdAndUp, xlAndUp } from '@/helpers/breakpoints';
export default {
  name: 'ProfitabilityCalculatorWrapperCmp',
  setup() {
    return { mdAndUp, lgAndUp, xlAndUp };
  },
};
</script>

<style lang="scss" scoped>
.ProfitabilityCalculatorWrapperCmp {
  --hero-height: 440px;
  position: relative;
  margin-top: calc(var(--header-height) * -1);
  .wrapper {
    display: grid;
    grid-template-rows: var(--hero-height) auto;
    grid-template-columns: repeat(1, 1fr);
    gap: 0;
    align-items: center;
    height: 100%;
    > * {
      position: relative;
    }
  }
  .row1 {
    min-height: var(--hero-height);
  }
  .negative-offset {
    padding-bottom: 160px;
    margin-left: 0;
    text-align: center;
    @include media-breakpoint-up(lg) {
      padding-bottom: 30px;
      margin-left: -30px;
      text-align: left;
    }
    display: flex;
    flex-flow: column-reverse;
    min-height: var(--hero-height);
    > * {
      font-weight: bold;
    }
  }
  figure.background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    max-width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: map-get($z, under);

    ::v-deep img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: 50% 50%;
    }
  }
  .ProfitabilityCalculatorCmp {
    margin-top: -150px !important;
    @include media-breakpoint-up(lg) {
      margin-top: -200px !important;
    }
  }
}
</style>
